<div class="modal-header text-left">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close">
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Time tracking history</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-8" [ngClass]="
      { 'col-12': numberOfEntries === 0 && !isAddingNewEntry && !selectedTimeTracking || !isAddingNewEntry && !selectedTimeTracking }
      ">
      <h3 class="number-entries" *ngIf="numberOfEntries === 1">
        {{ numberOfEntries }} entry,
        {{ jobsTimeTrackingService.timeTrackedFormatter(sumOfTimesTracked) }} in
        total.
      </h3>
      <h3 class="number-entries" *ngIf="numberOfEntries > 1">
        {{ numberOfEntries }} entries,
        {{ jobsTimeTrackingService.timeTrackedFormatter(sumOfTimesTracked) }} in
        total.
      </h3>
      @if(!timeTrackingInfo?.length && !isAddingNewEntry) {
      <ds-empty-state icon="tio-clock" title="No Time Tracking Entries"
        description="Start by adding time tracking entries or check back later to see updates."></ds-empty-state>
      } @else {
      <table class="table gray-bg">
        <thead>
          <tr>
            <th>STAFF</th>
            <th>STARTED AT</th>
            <th>TIME TRACKED</th>
            <th>NOTES</th>
            <th>EDITED</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let timeTracking of timeTrackingInfo" style="cursor: pointer"
            [ngClass]="{ selected: timeTracking.id === selectedTimeTracking?.id }"
            (click)="selectTimeTracking(timeTracking)">
            <td>
              <div class="assignee">
                <div class="avatar">
                  <img [src]="timeTracking.user.pictureUrl" />
                </div>
                <div class="username">
                  {{ timeTracking.user.full_name }}
                </div>
              </div>
            </td>
            <td>{{ timeTracking.start_date | date: "short" }}</td>
            <td>
              <span id="editable-time-{{ timeTracking.id }}" class="editable-time"><strong>{{
                  jobsTimeTrackingService.timeTrackedFormatter(
                  timeTracking.time_tracked
                  )
                  }}</strong>
              </span>
            </td>
            <td>{{ timeTracking.notes }}</td>
            <td>
              <span *ngIf="timeTracking.is_edited" style="margin-left: 16px">
                <i class="feather check"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      }
    </div>

    <div class="col-4">
      @if (selectedTimeTracking || isAddingNewEntry) {
      <div class="edit-time-tracking">
        <h4 class="modal-title" id="myModalLabel">Time tracking entry</h4>
        <div class="inputs-container">
          <div class="input">
            <label for="start-date">Started date</label>
            <p-datepicker [showButtonBar]="true" showClear="true" dateFormat="mm/dd/yy" dataType="date"
              [showTime]="true" [(ngModel)]="selectedTimeTracking.start_date"></p-datepicker>
          </div>
          <div class="input">
            <label for="time-tracked">Time tracked</label>
            <span #timeTracked id="editable-time" (blur)="updateTimeTracked(timeTracked.innerText)"
              (keydown)="updateTimeTrackedEnter($event)" [contentEditable]="true">{{
              jobsTimeTrackingService.timeTrackedFormatter(
              selectedTimeTracking.time_tracked
              )
              }}</span>
          </div>
        </div>
        <div class="input">
          <label for="notes">Notes</label>
          <textarea [(ngModel)]="selectedTimeTracking.notes" class="form-control" type="text" name="notes"></textarea>
        </div>
        <div class="footer-buttons">
          <button id="btn" class="btn btn-primary" (click)="isAddingNewEntry ? addNewEntry() : updateTimeTracking()">
            {{ isAddingNewEntry ? "Add" : "Save changes" }}
          </button>
          <button id="btn" class="btn btn-default" (click)="hideAddNewEntry()">
            Cancel
          </button>
        </div>
      </div>
      } @else {
      <div class="modal-body">
        <div></div>
      </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="showNewEntry()" [disabled]="isAddingNewEntry || selectedTimeTracking">
    New entry
  </button>
</div>